function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStateSuccess = function SvgStateSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M512 64.7C265 64.7 64.7 265 64.7 512S265 959.3 512 959.3 959.3 759 959.3 512 759 64.7 512 64.7zm262.2 334.1L431.8 731c-8.4 8.2-19.6 12.7-31.3 12.7h-.8c-12-.2-23.4-5.2-31.7-13.8L239.1 595.6c-17.2-17.9-16.6-46.4 1.3-63.6 17.9-17.2 46.4-16.6 63.6 1.3L401.6 635l309.9-300.7c17.8-17.3 46.3-16.9 63.6 1 17.4 17.7 17 46.2-.9 63.5z",
    style: {
      fill: "#30ca6f"
    }
  }));
};
export default SvgStateSuccess;